import { isEmptyObject } from "../../../utils/tests";
import { MatchChangeHpQuery, MatchChangeHpSubscription } from '../types';

/**
 * typeguard for MatchChangeHpQuery
 * @param MatchChangeHpQuery object passed to transformer
 */
export const isValidMatchChangeHpQuery = (obj: MatchChangeHpQuery): boolean => Boolean(obj?.data?.getMatchChange && !isEmptyObject(obj.data.getMatchChange));

/**
 * typeguard for MatchChangeHpSubscription
 * @param MatchChangeHpSubscription object passed to transformer
 */
export const isValidMatchChangeHpSubscription = (obj: MatchChangeHpSubscription): boolean => Boolean(obj?.data?.onUpdateMatchChangeById && !isEmptyObject(obj.data.onUpdateMatchChangeById));
